import { FC, ReactNode } from 'react'

import { clsx } from 'clsx'

import { Icon } from '../Icon/index.js'
import {
  CheckCircleIcon,
  ExclamationIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '../icons/index.js'
import { ToastStatus } from './ToastContext.js'

export type ToastIconProps = {
  status: ToastStatus
  children?: ReactNode
}

export const ToastIcon: FC<ToastIconProps> = ({ status, children }) => {
  let icon

  const iconClsx = [
    status === 'neutral' && 'text-content-subdued',
    status === 'error' && 'text-content-on-negative',
    status === 'warning' && 'text-content-on-attention',
    status === 'success' && 'text-content-on-positive',
    status === 'info' && 'text-content-on-highlight',
  ]

  switch (status) {
    case 'error':
      icon = <XCircleIcon />
      break
    case 'warning':
      icon = <ExclamationIcon />
      break
    case 'success':
      icon = <CheckCircleIcon />
      break
    case 'info':
      icon = <InformationCircleIcon />
      break
    case 'neutral':
      icon = children
      break
    default:
      break
  }

  return icon ? <Icon className={clsx('h-6 w-6', iconClsx)}>{icon}</Icon> : null
}
